import Constant from '@sailor/ksi-constants';

// 首页CID
export const HomePageCid = 'c_waimai_c_overseas_aatucy3n';

// 地址栏曝光BID
export const AddressBarViewBid = 'b_waimai_c_overseas_v9aaxwub_mv';

// 地址栏点击BID
export const AddressBarClickBid = 'b_waimai_c_overseas_v9aaxwub_mc';

// 首页定位状态
// 0 : 初始化：未启动首页定位 地址栏展示'定位中' /// i18n key :  shouye_address_locating
// 1 : 定位中：真实定位中 or 逆地理中 地址栏展示'定位中'
// 2 : 定位完成，但是逆地理失败：地址栏展示'未选择地址' /// i18n key : address_mainpage_addressnotchosen
// 3 : 使用默认旺角地址
// 4 : 匹配到真实定位300m内的收货地址
// 5 : 真实定位poi : 逆地理成功
// 6 : 在地图中选择的地点
// 7 ：手动选择的用户收货地址
// 8 : 定位失败后使用最近一次真实定位缓存
// 9 ： 定位失败后使用最近一次地图选点
// 10 ： 定位失败后使用最近一次收货地址记录
// 11 ： 切换用户后收货地址已过期，此时只能取到经纬度和地址名称，其他信息已被清空
export const LocatinStatus = {
  prepare: 0,
  locating: 1,
  regeoFailed: 2,
  defauleLocation: 3,
  actualUserAddress: 4,
  actualLocation: 5,
  selectedLocation: 6,
  selectedUserAddress: 7,
  cachedActualLocation: 8,
  cachedSelectedLocation: 9,
  cachedSelectedUserAddress: 10,
  overdueAddress: 11,
};

// 首页当前地址类型
// 0：默认旺角（regeo失败or定位失败）
// 1：定位后通过nearby获取的poi
// 2：地图选点
// 3：用户收货地址 含定位最近300米内收货地址
// -1 切换用户后收货地址已过期，此时只能取到经纬度和地址名称，其他信息已被清空
export const LocatinType = {
  overdueAddress: -1,
  default: 0,
  actualPoi: 1,
  selectedLocation: 2,
  userAddress: 3
};

export const validBizLine = [Constant.common.KSI_BIZ_LINE_KEEMART];
